<template>
  <div style="box-sizing: border-box;text-align: center;display: flex;justify-content:space-between" :style="{
    '--labelColor': option.attribute.label.color,
    '--labelSize': option.attribute.label.fontSize + 'px',
    '--labelLineHeight': labelLineHeight + 'px',
    '--numColor': option.attribute.num.color,
    '--numSize': option.attribute.num.fontSize+'px',
    '--numFont': option.attribute.num.fontFamily,
    lineHeight:height+'px'}">
    <div class="time-num" v-show="option.attribute.showYear">{{Math.floor(numData.day / 365)}}</div>
    <div class="time-label" v-show="option.attribute.showYear">年</div>
    <div class="time-num" v-show="!option.attribute.accuracy || option.attribute.accuracy>1">{{option.attribute.showYear ? numData.day % 365 : numData.day}}</div>
    <div class="time-label" v-show="!option.attribute.accuracy || option.attribute.accuracy>1">天</div>
    <div class="time-num" v-show="!option.attribute.accuracy || option.attribute.accuracy>2">{{numData.hour}}</div>
    <div class="time-label" v-show="!option.attribute.accuracy || option.attribute.accuracy>2">小时</div>
    <div class="time-num" v-show="!option.attribute.accuracy || option.attribute.accuracy>3">{{numData.minute}}</div>
    <div class="time-label" v-show="!option.attribute.accuracy || option.attribute.accuracy>3">分</div>
    <div class="time-num" v-show="!option.attribute.accuracy || option.attribute.accuracy>4">{{numData.second}}</div>
    <div class="time-label" v-show="!option.attribute.accuracy || option.attribute.accuracy>4">秒</div>
  </div>
</template>

<script>
import { getDefaultValue } from "@/utils/refresh-cpt-data";

export default {
  name: "cpt-time-run",
  props: {option: Object,height:Number, current: Object},
  watch: {
    'option.attribute.label.align': {
      handler() {
        this.calcLabelLingHeight();
      }
    },
    height(){
      this.calcLabelLingHeight();
    },
  },
  data(){
    return {
      numData:{
        day:0,
        hour:0,
        minute:0,
        second:0
      },
      timer:null,
      labelLineHeight: 0
    }
  },
  created() {
    this.calcLabelLingHeight();
    this.runTime(this.option.attribute)
  },
  methods:{
    calcLabelLingHeight(){
      let labelLineHeight = this.height
      if(this.option.attribute.label.align === 'top'){
        labelLineHeight = this.option.attribute.label.fontSize
      }else if(this.option.attribute.label.align === 'center'){
        labelLineHeight = this.height
      }else if(this.option.attribute.label.align === 'bottom'){
        labelLineHeight = this.height * 2 - this.option.attribute.label.fontSize
      }
      this.labelLineHeight = labelLineHeight
    },
    runTime(attr){
      const that = this;
      if(that.timer){
        clearInterval(that.timer);
        that.timer = null;
      }
      that.timer = setInterval(()=>{
        let targetTime = attr.targetTime
        const defaultValue = getDefaultValue(attr)
        if(defaultValue) {
          let date = defaultValue.replace(/\+/g, ' ')
          let isDate = new Date(date).toString()
          if(isDate != 'Invalid Date') {
            targetTime = date
          }
        }
        const timeStampTarget = new Date(targetTime) - 0
        const timeStamp2 = new Date() - 0
        if(attr.direction === 1){//顺时
          if(timeStamp2 < timeStampTarget){
            that.numData={day:0, hour:0, minute:0, second:0}
            return
          }
        }else{//倒计时
          if(timeStamp2 > timeStampTarget){
            that.numData={day:0, hour:0, minute:0, second:0}
            return
          }
        }
        const absTime = Math.abs(timeStamp2-timeStampTarget);
        that.numData.day = Math.floor(absTime / (24 * 60 * 60 * 1000))
        const timeStampHours = absTime % (24 * 60 * 60 * 1000)
        that.numData.hour = Math.floor(timeStampHours / (60 * 60 * 1000))
        const timeStampMinute = timeStampHours % (60 * 60 * 1000)
        that.numData.minute = Math.floor(timeStampMinute / (60 * 1000))
        const timeStampSecond = timeStampMinute % (60 * 1000)
        that.numData.second = Math.floor(timeStampSecond / 1000)
      },1000)
    }
  },
  beforeUnmount() {
    if(this.timer){
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
</script>

<style scoped>
.time-num{color:var(--numColor);font-size: var(--numSize);font-family: var(--numFont);}
.time-label{color:var(--labelColor);font-size: var(--labelSize);font-family: var(--labelFont);line-height: var(--labelLineHeight)}
</style>
